export default class Countdown {
  start(startDate, endDate, onTick, onComplete) {

    this.stop();

    startDate = startDate || new Date();


    const timeAPI = {
      DAYS: 1000 * 60 * 60 * 24,
      HOURS: 1000 * 60 * 60,
      MINUTES: 1000 * 60,
      SECONDS: 1000
    };

    let timeLeft = endDate - startDate;

    this._interval = setInterval(() => {
      if (timeLeft > 0) {
        let time = timeLeft;
        const days = Math.floor(time / (timeAPI.DAYS));
        time %= timeAPI.DAYS;
        const hours = Math.floor(time / (timeAPI.HOURS));
        time %= timeAPI.HOURS;
        const minutes = Math.floor(time / (timeAPI.MINUTES));
        time %= timeAPI.MINUTES;
        const seconds = Math.floor(time / (timeAPI.SECONDS));

        const countdown = {
          days: days,
          hours: hours,
          minutes: minutes,
          seconds: seconds
        };
        if (onTick) onTick(countdown);
        timeLeft -= 1000;
      } else {
        timeLeft -= 1000;

        const countdown = {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        };
        if (onTick) onTick(countdown);

        clearInterval(this._interval);
        if (onComplete) onComplete();
      }
    }, 1000);
  }


  stop() {
    clearInterval(this._interval);
  }
}



// WEBPACK FOOTER //
// ./src/Countdown.js